<template>
  <main-template>
    <v-row>
      <v-col>
        <span class="text-h4">Usuários </span>
        <e-help-tooltip :text="$constants.tooltips.usuarios.criarUsuario" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0 pb-0">
        <div class="d-flex mb-2 justify-space-between">
          <v-btn color="success" @click="criarUsuario" class="mr-2">Criar Usuário</v-btn>
          <v-text-field
            v-model="search"
            class="ml-2 search-input"
            append-icon="mdi-magnify"
            label="Pesquisar..."
            solo
            dense
            single-line
            hide-details
          />
        </div>
      </v-col>
      <v-col v-if="ehSuperAdmin" cols="12">
        <v-card outlined>
          <v-card-text class="d-flex align-center">
            <v-avatar color="primary" size="36" class="mr-4">
              <v-icon small color="white">fa fa-user</v-icon>
            </v-avatar>
            <div class="mr-4">
              <div class="text-subtitle-1 font-weight-medium">Avaliador de Autorizações</div>
              <div class="text-caption text--secondary">
                Responsável por liberar as aulas solicitadas fora do prazo pelos professores
              </div>
            </div>
            <v-select
              v-model="avaliadorSelecionado"
              :items="usuariosElegiveisAvaliador"
              :loading="carregandoAvaliador"
              :disabled="carregandoAvaliador"
              item-text="name"
              item-value="id"
              dense
              outlined
              hide-details
              class="ml-auto"
              style="max-width: 260px"
              @change="confirmarTrocaDeAvaliador"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col class="pt-0">
        <v-data-table
          :headers="table.headers"
          :items="outrosUsuariosList"
          :loading="carregandoUsuarios"
          :items-per-page="10"
          :custom-filter="dataTableFilter"
          :search="search"
          hide-default-footer
          class="elevation-1"
        >
          <template v-slot:body="{ items }">
            <tbody name="scroll-x-transition" is="transition-group" duration="150">
              <tr
                color="primary"
                :class="usuario.estaDeletado ? ['deleted'] : []"
                v-for="usuario of items"
                :key="usuario.id"
              >
                <td>{{ usuario.id }}</td>
                <!-- <td>{{ usuario.codigo }}</td> -->
                <td>{{ usuario.name }}</td>
                <td>{{ usuario.email }}</td>
                <td><e-user-role :value="usuario" /></td>
                <td>
                  <v-tooltip v-if="!usuario.estaDeletado" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="blue-grey lighten-3"
                        v-bind="attrs"
                        v-on="on"
                        @click="() => editarUsuario(usuario)"
                      >
                        <v-icon small>fa fa-edit </v-icon>
                      </v-btn>
                    </template>
                    <span>Editar usuario</span>
                  </v-tooltip>
                  <v-tooltip v-if="!usuario.estaDeletado" color="error" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="error"
                        v-bind="attrs"
                        v-on="on"
                        @click="() => deletarUsuario(usuario)"
                      >
                        <v-icon small>fa fa-trash </v-icon>
                      </v-btn>
                    </template>
                    <span>Apagar usuario</span>
                  </v-tooltip>
                  <v-tooltip v-if="usuario.estaDeletado" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="info"
                        v-bind="attrs"
                        v-on="on"
                        @click="() => recuperarUsuario(usuario)"
                      >
                        <v-icon small>fa fa-sync </v-icon>
                      </v-btn>
                    </template>
                    <span>Recuperar usuario</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>

        <e-paginate
          :current_page="paginate.current_page"
          :last_page="paginate.last_page"
          :pageNumber="pageNumber"
          @changeActionResponse="carregarUsuarios"
          :search="search"
        ></e-paginate>
      </v-col>
    </v-row>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";
import { dataTableFilter } from "@/plugins/searchQuery";
import Usuario from "../../Models/User";

export default {
  computed: {
    ...mapGetters("Auth", ["user"]),
    ehSuperAdmin() {
      return this.user?.roleName === "super-admin";
    },
  },
  data() {
    return {
      usuarios: [],
      carregandoUsuarios: false,
      usuariosLoaded: false,
      usuariosList: [],
      outrosUsuariosList: [],
      usuariosElegiveisAvaliador: [],
      avaliadorSelecionado: null,
      carregandoAvaliador: false,
      dataTableFilter,
      search: "",
      pageNumber: 0,
      paginate: {
        current_page: 0,
        last_page: 0,
      },

      table: {
        headers: [
          { text: "#", value: "id" },
          // { text: "Código", value: "codigo" },
          { text: "Nome", value: "name" },
          { text: "Login de acesso", value: "email" },
          { text: "Perfil", value: "role_id" },
          // { text: "Contexto", value: "contexto" },
          { text: "Ações", value: "actions", sortable: false },
        ],
      },
    };
  },
  mounted() {
    // this.$store.dispatch("Usuarios/loadUsuarios");
    this.carregandoUsuarios = true;
    this.$loaderService.open("Carregando Usuarios");
    this.carregarUsuarios(this.pageNumber);
    this.carregandoUsuarios = false;
    this.$loaderService.close();
    if (this.ehSuperAdmin) {
      this.carregarElegiveisAvaliador();
    }
  },
  watch: {
    carregandoUsuarios(value) {
      if (value && this.outrosUsuariosList.length === 0) {
        this.$loaderService.open("Carregando usuarios");
      } else {
        this.$loaderService.close();
      }
    },
    async search(val) {
      if (val.length > 1) {
        await this.carregarUsuarios(0, val);
      }
      if (!val) {
        await this.carregarUsuarios(0);
      }
    },
  },
  methods: {
    async carregarElegiveisAvaliador() {
      this.carregandoAvaliador = true;
      try {
        this.usuariosElegiveisAvaliador =
          await this.$services.usuariosService.listarElegiveisAvaliador();
        const avaliadorAtual = this.usuariosElegiveisAvaliador.find(
          (usuario) => usuario.avaliador_de_autorizacao
        );
        this.avaliadorSelecionado = avaliadorAtual ? avaliadorAtual.id : null;
      } catch (error) {
        this.$handleError(error);
      }
      this.carregandoAvaliador = false;
    },
    confirmarTrocaDeAvaliador(novoAvaliadorId) {
      const avaliadorAtual = this.usuariosElegiveisAvaliador.find(
        (usuario) => usuario.avaliador_de_autorizacao
      );
      const novoAvaliador = this.usuariosElegiveisAvaliador.find(
        (usuario) => usuario.id === novoAvaliadorId
      );

      const message = avaliadorAtual
        ? `<strong>${avaliadorAtual.name}</strong> deixará de ser avaliador. <strong>${novoAvaliador.name}</strong> passará a ser o novo responsável por liberar as aulas solicitadas pelos professores. Deseja continuar?`
        : `<strong>${novoAvaliador.name}</strong> passará a ser o responsável por liberar as aulas solicitadas pelos professores. Deseja continuar?`;

      this.$modals.warn({
        title: "Atenção!",
        message,
        buttons: [
          {
            text: "Cancelar",
            callback: () => {
              this.$modals.close();
              this.avaliadorSelecionado = avaliadorAtual ? avaliadorAtual.id : null;
            },
            props: { color: "warning", small: true },
          },
          {
            text: "Confirmar",
            callback: async () => {
              this.$modals.close();
              await this.alterarAvaliador(novoAvaliadorId);
            },
            props: { color: "success", small: true },
          },
        ],
      });
    },
    async alterarAvaliador(novoAvaliadorId) {
      this.carregandoAvaliador = true;
      try {
        await this.$services.usuariosService.atualizarAvaliador(novoAvaliadorId, true);
        this.$toast.success("Avaliador atualizado com sucesso");
        await this.carregarElegiveisAvaliador();
      } catch (error) {
        this.$handleError(error);
      }
      this.carregandoAvaliador = false;
    },
    async carregarUsuarios(pageNumber, query = null) {
      try {
        const response = await this.$services.usuariosService.syncAllPaginate(pageNumber, query);
        this.paginate = response.data;
        const usuarios = response.data.data.map((usuario) => new Usuario(usuario));
        this.outrosUsuariosList = usuarios;
      } catch (error) {
        this.$handleError(error);
      }
    },
    criarUsuario() {
      this.$router.push({ name: "usuarios.create" });
    },
    editarUsuario(usuario) {
      this.$router.push({ name: "usuarios.edit", params: { usuario_id: usuario.id } });
      // return usuario;
    },
    async deletarUsuario(usuario) {
      this.$modals.danger({
        title: "Cuidado!",
        message: "Tem certeza que deseja apagar este(a) usuario(a)?",
        confirmationCode: usuario.id,
        confirmationMessage: `Por favor, digite <strong>${usuario.id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => {
              this.$modals.close();
            },
            props: {
              color: "warning",
              small: true,
            },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Deletando Usuário(a)");
              try {
                await this.$services.usuariosService.deletarUsuario(usuario);
                this.$toast.success("Usuario deletado(a) com sucesso");
                await this.carregarUsuarios();
              } catch (error) {
                this.$handleError(error);
              }
              this.$loaderService.close();
            },
            props: {
              color: "error",
              // text: true,
              small: true,
            },
          },
        ],
      });
    },
    recuperarUsuario(usuario) {
      this.$modals.warn({
        title: "Atenção!",
        message: "Tem certeza que deseja recuperar este(a) usuario(a)?",
        confirmationCode: usuario.id,
        confirmationMessage: `Por favor, digite <strong>${usuario.id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => {
              this.$modals.close();
            },
            props: {
              color: "warning",
              small: true,
            },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Recuperando o(a) usuario(a)");
              try {
                await this.$services.usuariosService.recuperarUsuario(usuario);
                this.$toast.success("Usuario(a) recuperado(a) com sucesso");
                await this.carregarUsuarios();
              } catch (error) {
                this.$handleError(error);
              }
              this.$loaderService.close();
            },
            props: {
              color: "error",
              // text: true,
              small: true,
            },
          },
        ],
      });
    },
  },
};
</script>

<style></style>
